export default __webpack_public_path__ + "static/media/c5.4dc24d3d.png";